// Layout components
import SimpleLayout from '@/components/ui/layouts/SimpleLayout.vue'
import NavLayout from '@/components/ui/layouts/NavLayout.vue'

// Custom components
import DataPaginator from '@/components/utility/DataPaginator.vue'
import MdiIcon from '@/components/utility/MdiIcon.vue'
import AppPanel from '@/components/ui/parts/AppPanel.vue'
import ItemFlexContainer from '@/components/ui/parts/ItemFlexContainer.vue'
import ClearFlexContainer from '@/components/ui/parts/ClearFlexContainer.vue'
import ItemFlex from '@/components/ui/parts/ItemFlex.vue'
import ItemTollbar from '@/components/ui/parts/ItemToolbar.vue'
import ToolbarButton from '@/components/ui/parts/ToolbarButton.vue'
import DataLoader from '@/components/utility/DataLoader.vue'

export default {
  install(app) {
    //  Layout components
    app.component('SimpleLayout', SimpleLayout)
    app.component('NavLayout', NavLayout)

    // Custom components
    app.component('AppPanel', AppPanel)
    app.component('ItemFlexContainer', ItemFlexContainer)
    app.component('ClearFlexContainer', ClearFlexContainer)
    app.component('ItemFlex', ItemFlex)
    app.component('ItemToolbar', ItemTollbar)
    app.component('ToolbarButton', ToolbarButton)
    // Utility components
    app.component('DataPaginator', DataPaginator)
    app.component('MdiIcon', MdiIcon)
    app.component('DataLoader', DataLoader)
  }
}
